import i18next from "i18next";
import { useEffect, memo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  languageSelector,
  setLanguage,
} from "../../../features/language/languageSlice";

import {
  authLoginSelector,
  logoutUser,
} from "../../../features/auth/authLoginSlice";
import useComponentVisible from "../OutsideClick/useComponentVisible";
import ProfileDropdown from "./ProfileDropdown";
import { secureLoginSelector } from "../../../features/secureLogin/secureLoginSlice";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import {
  CheckValidOrderForUser,
  dashboardSelector,
} from "../../../features/dashboard/dashboardSlice";
import { useForm } from "react-hook-form";
import NoteNotification from "../Notes/NotesNotification";
import { notesSliceSelector } from "../../../features/notes/notesSlice";
import {
  lawFirmSelector,
  setDashboardLawfirm,
  setIsDashBoardLawfirmSelected,
} from "../../../features/lawFirm/lawFirmSlice";
import { IsDashBoardLawfirmSelected } from "../../../common/utils";
import { logoutUserWithOkta } from "../../okta/oktaLoginSlice";
import CryptoJS from "crypto-js";

const Header = () => {
  const dispatch = useDispatch();
  const lang = useSelector(languageSelector);
  const { isAuthenticated, userLogin, isUserLoggedInWithOkta } = useSelector(authLoginSelector);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);
  const { prosuiteDetails } = useSelector(secureLoginSelector);
  const { DashboardLawfirm, multipleFirmsUser } = useSelector(lawFirmSelector);

  useEffect(() => {
    i18next.changeLanguage(lang.value);
  }, [lang]);
  const languageChange = (newLang) => {
    dispatch(setLanguage(newLang));
  };
  const navigate = useNavigate();
  const logOutUser = () => {
    dispatch(isUserLoggedInWithOkta ? logoutUserWithOkta(dispatch) : logoutUser());
  };
  const { t } = useTranslation();

  const { register, handleSubmit, reset } = useForm();
  const { searchResults, error } = useSelector(dashboardSelector);
  const { notifications } = useSelector(notesSliceSelector);
  const [search, setSearch] = useState("");
  const [isNotificationsVisible, setIsNotificationsVisible] = useState(false);

  const notificationsRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      notificationsRef.current &&
      !notificationsRef.current.contains(event.target)
    ) {
      setIsNotificationsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const onSubmit = (data) => {
    data && data?.searchTerm && setSearch(data?.searchTerm);
    dispatch(
      CheckValidOrderForUser(
        IsDashBoardLawfirmSelected(DashboardLawfirm)
          ? DashboardLawfirm?.FirmID
          : 0,//parseInt(localStorage.getItem('selectedFirmId')) ||
        userLogin?.userId,
        data?.searchTerm || search,
        { toast }
      )
    );

    // reset();
  };

  const checkLawfirmValidationandNavigate = (navigateRoute) => {
    if (
      userLogin?.internalUser &&
      (DashboardLawfirm === null ||
        DashboardLawfirm === undefined ||
        DashboardLawfirm?.FirmID === "")
    ) {
      dispatch(setIsDashBoardLawfirmSelected(false));
    } else {
      window.location.replace(navigateRoute);
    }
  };

  useEffect(() => {
    if (searchResults && searchResults.isValidFile === true) {
      navigate(`ordersummary/${search}`);
      window.location.reload();
    } else if (searchResults && searchResults.isValidFile === false) {
      toast.error(t("noResults"));
    }
  }, [searchResults]);

  useEffect(() => {
    const encryptedLawfirm = window.localStorage.getItem("dashboardLawFirm");
    if (
          encryptedLawfirm &&
          encryptedLawfirm !== null &&
          encryptedLawfirm !== undefined 
        ) {
          let decryptedLawfirm = null;
          if (encryptedLawfirm) {
            const decryptedBytes = CryptoJS.AES.decrypt(
              encryptedLawfirm,
              process.env.REACT_APP_CRYPTO_KEY
            );
            decryptedLawfirm = JSON.parse(
              decryptedBytes.toString(CryptoJS.enc.Utf8)
            );
          }
          dispatch(setDashboardLawfirm(decryptedLawfirm));
        }
  }, []);

  return (
    <>
      {" "}
      <ToastContainer />{" "}
      <header className="bg-header-black flex justify-between h-header fixed w-full z-30">
        <Link to="/dashboard">
          <img
            src="../../images/ctic-logo-white.bf83e0e3.svg"
            alt="CTIC Logo"
          />
        </Link>

        <div className="header__container flex h-full flex-row">
          {isAuthenticated && prosuiteDetails === null && (
            <div className="relative flex align-middle mr-4">
              <form onSubmit={handleSubmit(onSubmit)}>
                <input
                  id="header-search"
                  className="align-middle rounded-sm border-b pl-12 my-2 h-10 bg-transparent w-64 text-white font-normal font-sans hover:text-header-black  hover:bg-white focus:border-0 focus-visible:border-0 focus-visible:inset-0 border-0 focus:bg-white focus:text-header-black focus:ring-white transition ease-in-out duration-500"
                  // onFocus="this.value=''"
                  {...register("searchTerm")}
                  type="search"
                  onChange={(e) => setSearch(e.target.value)}
                  onBlur={(e) => {
                    setSearch(e.target.value);
                    dispatch(
                      CheckValidOrderForUser(
                        IsDashBoardLawfirmSelected(DashboardLawfirm)
                          ? parseInt(DashboardLawfirm?.FirmID)
                          :  0,//parseInt(localStorage.getItem('selectedFirmId')) ||
                        userLogin?.userId,
                        parseInt(e.target.value),
                        { toast }
                      )
                    );
                  }}
                  disabled={
                    multipleFirmsUser &&
                    !IsDashBoardLawfirmSelected(DashboardLawfirm)
                  }
                // value="Search by Order /"
                />
              </form>
              <div className="search__container-white  flex absolute  ml-2 hover:ml-5  top-4 left-0 pointer-events-none delay-1000">
                <img src="../../images/search.acca3785.svg" alt="Seach Icon" />
              </div>

              <div className="search__container-black hidden  absolute ml-2 hover:ml-5  top-4 left-0 pointer-events-none ">
                <img
                  src="../../images/search-black.feb868a2.svg"
                  alt="Seach Icon"
                />
              </div>
            </div>
          )}

          <ul className="flex">
            {isAuthenticated && prosuiteDetails === null && (
              <>
                <div ref={ref}>
                  <li className="bg-secondary-blue">
                    <button
                      type="button"
                      onClick={() =>
                        setIsComponentVisible((prev) => {
                          return !prev;
                        })
                      }
                      className="flex items-center justify-between w-full px-8 py-4 text-white outline-none
                       border-[1px] border-transparent
                       focus-visible:border focus-visible:border-primary-yellow
                       focus:border focus:border-primary-yellow
                       hover:bg-secondary-blue-link
                     "
                    >
                      {t("MenuOfServices")}
                      <svg
                        className="w-5 h-5 ml-1"
                        aria-hidden="true"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    {isComponentVisible && (
                      <div className="z-10 font-normal bg-white divide-y divide-gray-100 w-[217px] ">
                        <ul
                          className="py-1 text-sm text-neutrals-black w-full"
                          aria-labelledby="dropdownLargeButton"
                        >
                          <li>
                            <button
                              onClick={() => {
                                checkLawfirmValidationandNavigate("/order");
                              }}
                            >
                              <span
                                className="block  w-full px-4 py-2 text-neutrals-black 
                               hover:bg-[/E8F3FA]  hover:text-shadow
                               focus:bg-[/E8F3FA] focus:text-shadow
                               focus-visible:outline-none
                             "
                              >
                                {t("titleInsuranceItem")}
                              </span>
                            </button>
                          </li>

                          <li>
                            <button
                              onClick={() => {
                                !userLogin?.internalUser ?
                                  navigate("/idverification") :
                                  (
                                    multipleFirmsUser ||
                                      IsDashBoardLawfirmSelected(DashboardLawfirm)
                                      ? checkLawfirmValidationandNavigate(
                                        "/idverification"
                                      )
                                      : "");
                              }}
                            >
                              <span
                                className={`block  w-full px-4 py-2 
                               ${!userLogin?.internalUser ?
                                    "hover:bg-[/E8F3FA] text-neutrals-black  hover:text-shadow focus:bg-[/E8F3FA] focus:text-shadow focus-visible:outline-none" :
                                    (multipleFirmsUser ||
                                      IsDashBoardLawfirmSelected(DashboardLawfirm)
                                      ? "hover:bg-[/E8F3FA] text-neutrals-black  hover:text-shadow focus:bg-[/E8F3FA] focus:text-shadow focus-visible:outline-none"
                                      : "text-gray-400")
                                  }
                             `}
                              >
                                {t("idVerificationItem")}
                              </span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    )}
                  </li>
                </div>
                <div ref={notificationsRef}>
                  <li className="relative">
                    <button
                      onClick={() =>
                        setIsNotificationsVisible((prev) => {
                          return !prev;
                        })
                      }
                      className="btn__header  h-header w-auto hover:border-transparent"
                    >
                      <div
                        style={{ position: "relative", display: "inline-block" }}
                      >
                        <svg
                          fill="#ffffff"
                          height="30px"
                          width="30px"
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          // xmlns:xlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 611.999 611.999"
                        // xml:space="preserve"
                        >
                          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            <g>
                              <g>
                                <g>
                                  <path d="M570.107,500.254c-65.037-29.371-67.511-155.441-67.559-158.622v-84.578c0-81.402-49.742-151.399-120.427-181.203 C381.969,34,347.883,0,306.001,0c-41.883,0-75.968,34.002-76.121,75.849c-70.682,29.804-120.425,99.801-120.425,181.203v84.578 c-0.046,3.181-2.522,129.251-67.561,158.622c-7.409,3.347-11.481,11.412-9.768,19.36c1.711,7.949,8.74,13.626,16.871,13.626 h164.88c3.38,18.594,12.172,35.892,25.619,49.903c17.86,18.608,41.479,28.856,66.502,28.856 c25.025,0,48.644-10.248,66.502-28.856c13.449-14.012,22.241-31.311,25.619-49.903h164.88c8.131,0,15.159-5.676,16.872-13.626 C581.586,511.664,577.516,503.6,570.107,500.254z M484.434,439.859c6.837,20.728,16.518,41.544,30.246,58.866H97.32 c13.726-17.32,23.407-38.135,30.244-58.866H484.434z M306.001,34.515c18.945,0,34.963,12.73,39.975,30.082 c-12.912-2.678-26.282-4.09-39.975-4.09s-27.063,1.411-39.975,4.09C271.039,47.246,287.057,34.515,306.001,34.515z M143.97,341.736v-84.685c0-89.343,72.686-162.029,162.031-162.029s162.031,72.686,162.031,162.029v84.826 c0.023,2.596,0.427,29.879,7.303,63.465H136.663C143.543,371.724,143.949,344.393,143.97,341.736z M306.001,577.485 c-26.341,0-49.33-18.992-56.709-44.246h113.416C355.329,558.493,332.344,577.485,306.001,577.485z"></path>{" "}
                                  <path d="M306.001,119.235c-74.25,0-134.657,60.405-134.657,134.654c0,9.531,7.727,17.258,17.258,17.258 c9.531,0,17.258-7.727,17.258-17.258c0-55.217,44.923-100.139,100.142-100.139c9.531,0,17.258-7.727,17.258-17.258 C323.259,126.96,315.532,119.235,306.001,119.235z"></path>{" "}
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                        {notifications.length > 0 && (
                          <span
                            style={{
                              position: "absolute",
                              top: "2px",
                              right: "2px",
                              height: "10px",
                              width: "10px",
                              backgroundColor: "red",
                              borderRadius: "50%",
                              border: "2px solid white",
                            }}
                          ></span>
                        )}
                      </div>
                    </button>
                    {isNotificationsVisible && (

                      <NoteNotification userId={userLogin?.userId} t={t} />
                    )}
                  </li>
                </div>
              </>


            )}
            <li className="h-full ">
              <button
                onClick={() =>
                  languageChange(lang.value === "en" ? "fr" : "en")
                }
                className="btn__header bg-secondary-burgundy h-header hover:bg-secondary-burgundy-hover hover:border-transparent"
              >
                EN/FR
              </button>
            </li>
            <ProfileDropdown
              isAuthenticated={isAuthenticated}
              userLogin={userLogin}
              logOutUser={logOutUser}
              prosuiteDetails={prosuiteDetails}
              IsDashBoardLawfirmSelected={IsDashBoardLawfirmSelected}
              multipleFirmsUser={multipleFirmsUser}
              lang={lang}
              t={t}
            />
          </ul>
        </div>
      </header>
    </>
  );
};

export default memo(Header);
